const ChannelViewMaxHeader = () => {
  return (
    <>
      <div className=" border-radius me-0 bg-nav border border-radius-top-end-2xl position-sticky top-0 z-index-2">
        <div className=" d-flex justify-content-between align-items-center">
          <div className="100">
            <div className=" d-flex justify-content-start align-items-center gap-1 p-2">
              <div className=" border-radius-2xl border" style={{width:"48px" , height:"48px" ,borderRadius:"50%" }}>
                <div className="text-center  categories-bg-mini">
                  <img
                    alt=""
                    src="../../assets/img/stores/store-1.png"
                    className="avatar "
                  />
                </div>
              </div>
              <div className=" lh-1">
                <b className=" text-lg fw-bolder text-black">
                  Amazon
                  <i className="bi bi-patch-check-fill text-info fs-6 ms-1"></i>
                </b>
                <div>
                  <b className=" text-xs fw-normal text-black">
                    10.5M followers
                  </b>
                </div>
              </div>
            </div>
          </div>
          <div className="100">
            <div className="d-flex gap-2 px-2">
              <li className="avatar avatar-sm border border-radius-2xl bg-gray-100">
                <a href="/">
                  <i className="bi bi-bell fs-5 text-black"></i>
                </a>
              </li>
              <li className="avatar avatar-sm border border-radius-2xl bg-gray-100 dropdown">
                <div
                  id="channelViewOptions"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bi bi-three-dots fs-5 text-black"></i>
                </div>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="channelViewOptions"
                >
                  <li>
                    <a className="dropdown-item fw-bold text-black" href="/">
                      Pin
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item fw-bold text-black" href="/">
                      Mute
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item fw-bold text-black" href="/">
                      Unsubscribe
                    </a>
                  </li>
                </ul>
              </li>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChannelViewMaxHeader;
